<template>
  <div class="manage">
    <el-drawer class="visitor-drawer" :with-header="false" :visible.sync="addDrawer.show" size="550px">
      <div class="drawer-header">
        <h3>邀约权限员工添加</h3>
      </div>
      <div class="drawer-content">
        <el-form ref="addForm" label-width="80" class="drawer-form" :model="addDrawer.form">
          <el-form-item prop="searchType" label="搜索类型:">
            <el-radio-group v-model="addDrawer.form.searchType">
              <el-radio label="name" key="name">员工姓名</el-radio>
              <el-radio label="workId" key="workId">员工工号</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="name" label="员工姓名:" v-show="addDrawer.form.searchType === 'name'">
            <el-input v-model="addDrawer.form.name" placeholder="请输入员工姓名" style="width: 350px">
              <el-button slot="append" icon="el-icon-search" @click="onSearchEmployee"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item prop="workId" label="员工工号:" v-show="addDrawer.form.searchType === 'workId'">
            <el-input v-model="addDrawer.form.workId" placeholder="请输入员工工号" style="width: 350px">
              <el-button slot="append" icon="el-icon-search" @click="onSearchEmployee"></el-button>
            </el-input>
          </el-form-item>
        </el-form>
        <el-table class="drawer-table" :data="addDrawer.searchResult" border>
          <el-table-column prop="name" label="员工姓名" align="center"></el-table-column>
          <el-table-column prop="workId" label="员工工号" align="center"></el-table-column>
          <el-table-column prop="departmentName" label="员工部门" align="center"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button size="mini" key="01" type="primary" @click="doAddEmployee(scope.row)" v-if="scope.row.inviteAuth !=='VALID'">添加</el-button>
              <el-button size="mini" key="02" type="primary" v-else disabled>已添加</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <div class="drawer-bottom">
        <el-button size="mini" @click="addDrawer.show = false">取 消</el-button>
      </div>
    </el-drawer>
    <el-drawer class="visitor-drawer" :with-header="false" :visible.sync="addBatchDrawer.show" size="550px">

      <div class="my-header-batch">
        <div class="header-title-box">批量添加</div>
        <div class="btn-area">
          <span style="width: 124px"></span>
          <el-button size="small" type="primary" @click="downloadExcel">模板下载</el-button>
          <span style="width: 100px"></span>
          <el-upload ref="upload" action="#" :on-change="handleFileChange" :auto-upload="false"
                     :file-list="addBatchDrawer.fileList" :multiple="false" :limit="1">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          </el-upload>
        </div>
      </div>

      <el-main class="my-el-main">
        <el-table :data="addBatchDrawer.searchResult" border style="width: 100%">
          <el-table-column v-for="item in formLabel" :key="item.prop" :prop="item.prop" :label="item.label"></el-table-column>
        </el-table>
      </el-main>

      <el-footer>
        <div class="footer-content">
          <el-button size="mini" type="primary" @click="onSubmitAddBatch">确认</el-button>
          <el-button size="mini" @click="addBatchDrawer.show = false">取消</el-button>
        </div>
      </el-footer>

    </el-drawer>


    <div class="header">
      <div class="left">
        <el-row>
          <h3 style="color: green; margin-top: 0">员工邀约权限管理</h3>
        </el-row>

        <el-row class="left-content">
          <el-input prefix-icon="el-icon-search" placeholder="请输入员工姓名" size="small" clearable
                    style="width: 400px; cursor: pointer" v-model="searchContent">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-row>
      </div>

      <div class="right">
        <el-button type="primary" size="mini" @click="addEmployee()" :disabled="!hasCommitPermission">添加成员
        </el-button>
        <el-button plain size="mini" @click="addEmployeeBatch()" :disabled="!hasCommitPermission">批量添加
        </el-button>
      </div>
    </div>

    <div class="content">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column v-for="(item, index) in formLabel" :key="index" :prop="item.prop" :label="item.label" :width="item.width">
          <template slot-scope="scope">
            <template v-if="item.type === 1">
              <template v-if="phoneNumShow">{{ scope.row[item.prop] }}</template>
              <template v-else> {{ scope.row[item.prop] | phNoFilter }}</template>
            </template>
            <template v-else>{{ scope.row[item.prop] }}</template>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="120px">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="tableDelete(scope.row)" :disabled="!hasCommitPermission">移除权限</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination layout="total, sizes, prev, pager, next" :total="totalCount" :page-sizes="pageSizes"
                       :page-size.sync="curPageSize" :pager-count="5"
                       :current-page.sync="curPageIndex" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {mixin_page_table} from '@/utils/mixin'
import {manage_mixin_table} from './manage-mixin'
import {getEmployeeByPage2, guardSearchEmployee, updateEmployee} from '@/api/organize-api'
import {downloadStaticExcelByPath} from "@/utils/commonUtils";


export default {
  name: "InvitePermissionPage",
  mixins: [mixin_page_table, manage_mixin_table],

  mounted() {
    this.loadTreeData()
    this.refreshTableData()
  },

  data() {
    return {
      searchContent: "",

      tableData: [],
      tableSelectRow: {},

      optionSelect: [],
      optionSelectValue: {
        id: -2,//初始化，没有其它意义
        label: ""
      },
      treeSelectValue: "",
      treeData: [],

      addDrawer: {
        show: false,
        form: {
          searchType: "name",
          name: "",
          workId: "",
        },
        searchResult: []
      },
      addBatchDrawer: {
        show: false,
        searchResult: [],
        fileList: [],
      },

      drawer: false,
      formType: "",
      form: {},
      formLabel: [
        {prop: 'name', label: '员工姓名', width: ""},
        {prop: 'workId', label: '员工工号', width: ""},
        {prop: 'departmentName', label: '所属部门', width: ""},
      ],

      roleList: [],

    };
  },

  computed: {
    ...mapState(['loginInfo']),

    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return this.$store.state.myPermissions.includes("ROLE_MANAGE_MODIFY")
        default:
          return false
      }
    }

  },
  methods: {
    search() {
      this.curPageIndex = 1
      this.refreshTableData()
    },
    onSearchEmployee() {
      let postData = {}
      if (this.addDrawer.form.searchType === "name") {
        postData.name = this.addDrawer.form.name
      } else {
        postData.workId = this.addDrawer.form.workId
      }
      this.addDrawer.searchResult = []
      guardSearchEmployee(postData).then(({data}) => {
        if (data.code === 200) {
          this.addDrawer.searchResult = data.data
        }
      }).catch(err => {
        console.log("onSearchEmployee err => ", err)
      })
    },
    doAddEmployee(employee) {
      let postData = {
        id: employee.id,
        inviteAuth: "VALID"
      }
      updateEmployee(postData).then(({data}) => {
        if (data.code === 200) {
          this.$message.success("邀约权限添加成功")
          this.$set(employee, "inviteAuth", "VALID")
          this.refreshTableData()
        }
      })
    },

    addEmployee() {
      this.addDrawer = {
        show: true,
        form: {
          searchType: "name",
          name: "",
          workId: "",
        },
        searchResult: [],
      }
    },


    addEmployeeBatch() {
      this.addBatchDrawer = {
        show: true,
        searchResult: [],
        fileList: [],
      }
    },

    downloadExcel() {
      const path = "/static/temp/批量添加员工邀约权限模版.xlsx"
      const fileName = "批量添加员工邀约权限模版.xlsx"
      downloadStaticExcelByPath(path, fileName)

    },

    handleFileChange(file, fileList) {
      let result = file.name.indexOf(".xlsx")
      if (result) {
        this.dealExcel(file)
      } else {
        this.$message.error('请上传正确的表格');
      }
    },

    dealExcel(file) {
      console.log("@@@", "dealExcel file", file);
      const XLSX = require('xlsx');

      let rABS = true;
      let that = this
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result

        if (!rABS) data = new Uint8Array(data);
        let workbook = XLSX.read(data, {type: rABS ? 'binary' : 'array'});
        let firstSheetName = workbook.SheetNames[0]
        const sheet = workbook.Sheets[firstSheetName]
        const range = XLSX.utils.decode_range(sheet['!ref']);
        range.s.r = 1; // 从第2行开始读取数据

        const result = XLSX.utils.sheet_to_json(sheet, {range})
        console.log("@@@@", "XLSX.result", result);
        that.dealExcelContent(result)
      }
      if (rABS) reader.readAsBinaryString(file.raw); else reader.readAsArrayBuffer(file.raw);
    },

    async dealExcelContent(result) {
      let workIds = result.map(item => item.员工工号)
      console.log("get workIds =>", workIds)
      let employeeList = []
      for (let i = 0; i < workIds.length; i++) {
        let workId = workIds[i]
        const searchParam = {workId: workId}
        let res = await guardSearchEmployee(searchParam)
        if (res.data.code === 200 && res.data.data.length > 0) {
          employeeList.push(res.data.data[0])
        } else {
          this.$message.error(`第${i + 1}行工号'${workIds[i]}'的员工不存在，请检查后重试`)
          return
        }
      }
      this.addBatchDrawer.searchResult = employeeList
    },

    async onSubmitAddBatch() {
      if (this.addBatchDrawer.searchResult.length === 0) {
        this.$message.error("请选择需要添加邀约权限的员工")
        return
      }
      const loading = this.$loading({
        lock: true,        // 锁定屏幕，防止用户点击
        text: '加载中...',  // 显示的提示文本
        spinner: 'el-icon-loading',  // 设置加载图标，默认为旋转的小圆圈
        background: 'rgba(255, 255, 255, 0.7)'  // 背景色，默认半透明白色
      });


      for (let i = 0; i < this.addBatchDrawer.searchResult.length; i++) {
        if (this.addBatchDrawer.searchResult[i].inviteAuth === "VALID") {
          continue
        }
        let postData = {
          id: this.addBatchDrawer.searchResult[i].id,
          inviteAuth: "VALID"
        }
        await updateEmployee(postData)
      }
      this.refreshTableData()

      loading.close()
      this.$message.success("邀约权限添加成功")
      this.addBatchDrawer.show = false
    },

    tableDelete(employee) {

      let postData = {
        id: employee.id,
        inviteAuth: "INVALID"
      }
      updateEmployee(postData).then(({data}) => {
        if (data.code === 200) {
          this.$message.success("邀约权限移除成功")
          this.refreshTableData()
        }
      })
    },

    refreshTableData() {
      let pageNum = this.curPageIndex
      let pageSize = this.curPageSize
      let searchName = this.searchContent
      let postData = {current: pageNum, size: pageSize, name: searchName, inviteAuth: "VALID"}
      getEmployeeByPage2(postData).then(({data}) => {
        if (data.code === 200) {
          this.tableData = data.data.data
          this.totalCount = data.data.totals
        }
      }).catch(err => {
        console.log("getEmployeeByPage =>", err)
      })
    },

  },

}

</script>

<style lang="less" scoped>
.visitor-drawer {
  .drawer-header {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .drawer-content {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;

    height: calc(100vh - 120px);
    overflow: auto;

    .drawer-form {
      width: 450px;
      margin: 20px;
    }
  }

  .drawer-bottom {
    height: 60px;

    display: flex;
    align-items: center;
    justify-content: center;
  }
}


.dialog-main {
  .dialog-notify {
    font-size: 12px;
    margin-top: 8px;
    margin-bottom: 8px;
  }
}

.manage {

  .edit-form {
    display: flex;
    flex-direction: column;
    text-align: center;
    height: 100%;

    .header-content {
      margin-bottom: 20px;
    }


    .footer-content {
      text-align: center;
      flex: 0 0 auto;
    }
  }

  .header {
    display: flex;
    justify-content: space-between;

    .left-content {

      margin: 0 0 20px 0; //上 右 下 左
    }

    .right {
      margin: 60px 20px 0 0; //上 右 下 左
    }
  }

}

.visitor-drawer {
  .drawer-header {
    height: 60px;
    background-color: #f5f7fa;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .drawer-content {
    height: calc(100vh - 120px);
    overflow: auto;

    .drawer-form {
      margin: 20px;
    }
  }

  .drawer-bottom {
    height: 60px;
    background-color: #f5f7fa;

    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.my-header {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 150px;

  .header-title-box {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}

.my-el-main {
  height: calc(100% - 210px);
  box-sizing: border-box;
  padding: 0;
}

.main-content {
  flex: 1 0 auto;

}

.my-header-batch {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 150px;

  .header-title-box {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}

.btn-area {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;
}

.footer-content {
  text-align: center;
  flex: 0 0 auto;
}
</style>
